const fields = (t) => ({
    config: { columns: 1 },
    fields: [
        {
            name: "unitCartonDimensions",
            label: t ? t("forms.unit_carton_dimensions") : "Wymiar kartonika jednostkowego (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "packageSize",
            label: t ? t("forms.package_size") : "Wielkość pakietu (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "cartonOrientationOnPallet",
            label: t ? t("forms.carton_orientation") : "Orientacja kartoników na palecie",
            column: 1,
            type: "text"
        },
        {
            name: "cartonsPerLayer",
            label: t ? t("forms.cartons_per_layer") : "Ilość kartoników w warstwie",
            column: 1,
            type: "text"
        },
        {
            name: "layersPerPackage",
            label: t ? t("forms.layers_in_package") : "Ilość warstw w pakiecie",
            column: 1,
            type: "text"
        },
        {
            name: "packageFoilType",
            label: t ? t("forms.package_foil_type") : "Rodzaj folii pakietowej",
            column: 1,
            type: "text"
        },
        {
            name: "packageFoilWidth",
            label: t ? t("forms.package_foil_width") : "Szerokość folii pakietowej (mm)",
            column: 1,
            type: "text"
        },
        {
            name: "packageFoilThickness",
            label: t ? t("forms.package_foil_thickness") : "Grubość folii pakietowej (µm)",
            column: 1,
            type: "text"
        },
        {
            name: "packagingMethod",
            label: t ? t("forms.packaging_method") : "Sposób pakietowania",
            column: 1,
            type: "text"
        }
    ]
});

export default fields;
